package models

import kotlinx.serialization.Serializable

@Serializable
data class PhysicState(
    val id: Int,
    val x: Float,
    val y: Float,
    val velocityX: Float,
    val velocityY: Float
)

@Serializable
data class PlayerCommands(
    val left: Boolean = false,
    val right: Boolean = false,
    val up: Boolean = false,
    val down: Boolean = false
) : PacketData()

